import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <div className="main-layout">
      <Outlet /> {/* This will render the login page */}
    </div>
  );
};

export default MainLayout;

